import _styled from "styled-components";
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
/** A MenuList component which wraps an HTML unordered list */
const MenuList = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    style,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: ref,
    className: className,
    $_css: [{
      listStyle: 'none',
      padding: "".concat(theme.spacing.XS, "px 0px"),
      margin: 0
    }, style]
  }, children);
});
MenuList.displayName = 'MenuList';
MenuList.propTypes = {
  /** The content to category */
  children: PropTypes.any,
  /* Styles applied to the root element */
  style: stylePropType,
  /* Class applied to the root element */
  className: PropTypes.string
};
export default MenuList;
var _StyledDiv = _styled("div").withConfig({
  displayName: "MenuList___StyledDiv",
  componentId: "sc-14jofm9-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=MenuList.js.map